import { useSuspenseQuery } from "@tanstack/react-query";
import { CabecalhoPagina, Tela } from "@/components/casca/CabecalhoPagina";
import { Aviso } from "@/components/casca/formulario";
import { Vazio } from "@/components/casca/Vazio";
import { AcoesClinica } from "@/components/sistema/AcoesClinica";
import { sistemaQuery } from "../consultas";

/**
 * A visão de quem opera o LummiChat: todas as clínicas. Quem não é dono da
 * plataforma nem chega aqui — o roteador responde "não achei", e a API, 403.
 */
export function Sistema() {
  const {
    data: { clinicas, clinicaAtual },
  } = useSuspenseQuery(sistemaQuery());

  return (
    <Tela>
      <CabecalhoPagina
        titulo="Sistema"
        descricao="Todas as clínicas da plataforma. Entrar numa delas te põe como administrador — para dar suporte, não para o dia a dia."
      />

      {clinicas.length === 0 ? (
        <Vazio icone="escudo" titulo="Nenhuma clínica no banco">
          A primeira aparece assim que alguém criar a dela pelo onboarding.
        </Vazio>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="overflow-x-auto rounded-[14px] bg-[var(--color-cartao)] shadow-cartao">
            <table className="w-full min-w-[680px] text-left text-sm">
              <thead className="border-b border-[var(--color-borda)] text-xs font-bold tracking-[0.05em] text-[var(--color-fraco)] uppercase">
                <tr>
                  <th className="px-4 py-3">Clínica</th>
                  <th className="px-4 py-3">Slug</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Criada em</th>
                  <th className="px-4 py-3 text-right">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[var(--color-borda)] text-[var(--color-tinta)]">
                {clinicas.map((c) => (
                  <tr key={c.id} className="transition-colors hover:bg-[var(--color-painel)]">
                    <td className="px-4 py-3 font-semibold">
                      {c.nome}
                      {c.id === clinicaAtual && (
                        <span className="ml-2 rounded-full bg-[var(--color-realce)] px-2.5 py-0.5 text-xs font-semibold text-[var(--color-marca-forte)]">
                          você está aqui
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3 font-mono text-[12.5px] text-[var(--color-suave)]">{c.slug}</td>
                    <td className="px-4 py-3">
                      <span
                        className={
                          "rounded-full px-2.5 py-0.5 text-xs font-semibold " +
                          (c.status === "ativo" ? "bg-[var(--color-realce)] text-[var(--color-marca-forte)]" : "bg-[var(--color-painel)] text-[var(--color-suave)]")
                        }
                      >
                        {c.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-[var(--color-suave)]">
                      {new Date(c.criado_em).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" })}
                    </td>
                    <td className="px-4 py-3">
                      <AcoesClinica id={c.id} slug={c.slug} nome={c.nome} status={c.status} ativa={c.id === clinicaAtual} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Aviso tom="info">
            Arquivar é o passo reversível: a clínica para de responder no WhatsApp e some do seletor, mas o
            cadastro inteiro fica. Excluir só vale para clínica já arquivada, e leva junto conversas, fichas e
            conexão — o cascade do banco.
          </Aviso>
        </div>
      )}
    </Tela>
  );
}
